import { GpsTrackerResponse } from "../../../shared/response/hardware/GpsTrackerResponse";
import { GpsTrackerAsignarSavePayload } from "../../../shared/services/api/payload/hardware/GpsTrackerAsignarSavePayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { GpsTrackerService } from "./GpsTrackerService";

/**
 * Adaptador para usar el modal de asignación (BaseSmallModalFormComponent).
 * Delega en GpsTrackerService.asignar (gRPC `Asignar`).
 */
export class GpsTrackerAsignarService extends ServiceSaveBase<GpsTrackerResponse, GpsTrackerAsignarSavePayload> {
  /** Asigna a un cliente o devuelve a oficina: delega en `GpsTrackerService.asignar` (gRPC `Asignar`). */
  protected sendSave(payload: GpsTrackerAsignarSavePayload): Promise<GpsTrackerResponse> {
    return GpsTrackerService.instance.asignar(payload.id!, { clienteId: payload.clienteId });
  }
}
